import {lazy} from 'react';

export const NewsTimelineLazy = lazy(() => import(/* webpackChunkName: "newsTimeline" */ '.'));
